import type { ReactNode } from "react";

import { ChevronLeft } from "./icons";
import { LargeTitle } from "./LargeTitle";

/** Back + optional trailing command: the header of every detail screen. */
export function DetailHeader({
  title,
  onBack,
  backLabel = "Back",
  trailing,
  largeTitle = false,
  eyebrow,
}: {
  title: string;
  onBack: () => void;
  backLabel?: string;
  trailing?: ReactNode;
  /** Render the title as a large title below the row (Soft layout). */
  largeTitle?: boolean;
  /** Small line above the large title. */
  eyebrow?: ReactNode;
}) {
  return (
    <header className="px-gutter">
      <div className="flex h-11 items-center gap-2">
        <button
          type="button"
          onClick={onBack}
          aria-label={backLabel}
          className="-ml-2 inline-flex min-h-11 min-w-11 items-center gap-0.5 rounded-lg px-2 text-body font-medium text-accent-fg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus"
        >
          <ChevronLeft size={20} />
          <span>{backLabel}</span>
        </button>
        {largeTitle ? (
          <span className="flex-1" />
        ) : (
          <h1 className="min-w-0 flex-1 truncate text-headline text-fg">
            {title}
          </h1>
        )}
        {trailing}
      </div>
      {largeTitle && (
        <LargeTitle title={title} eyebrow={eyebrow} className="pb-2 pt-1" />
      )}
    </header>
  );
}
